import type { NotificationBus } from './NotificationBus';
import type { NotificationDto } from '../types';

/** Событие общего фонового поллера (assets/new/js/user-status). */
const USER_STATUS_EVENT = 'yc:user-status';

type UserStatusDetail = { notifications?: NotificationDto[] };

/**
 * Берёт уведомления из общего статуса вкладки вместо собственного опроса.
 *
 * Главный бандл сайта раз в интервал запрашивает /status и раздаёт результат
 * DOM-событием: popup собирается отдельным vite и импортировать тот модуль не
 * может, поэтому связь — через событие, а не через import.
 *
 * Собственного расписания у транспорта нет вообще: пока общий поллер молчит
 * (например, вкладка скрыта), молчит и он. Это и есть смысл объединения —
 * см. docs/perf/POLLING_ENDPOINTS_OPTIMIZATION.md.
 */
export class SharedStatusTransport {
  private readonly bus: NotificationBus;
  private listening = false;

  constructor(opts: { bus: NotificationBus }) {
    this.bus = opts.bus;
  }

  /** Есть ли на странице общий поллер: по этому признаку выбирается транспорт. */
  static isAvailable(): boolean {
    return document.querySelector('[data-user-status]') !== null;
  }

  start(): void {
    if (this.listening) return;
    this.listening = true;
    document.addEventListener(USER_STATUS_EVENT, this.onStatus as EventListener);
  }

  stop(): void {
    this.listening = false;
    document.removeEventListener(USER_STATUS_EVENT, this.onStatus as EventListener);
  }

  private onStatus = (event: CustomEvent<UserStatusDetail>): void => {
    const items = event.detail?.notifications ?? [];
    for (const item of items) {
      this.bus.emit('notifications', { type: 'notification.created', payload: item });
    }
  };
}
